<template>
  <div style="height: 500px; width: 100%" :id="'mapCardview'+id">
      <l-map
        ref="map"
        :zoom="zoom"
        :max-bounds="maxBounds"
        :center="center"
        :options="mapOptions"
        style="height: 100%; z-index:0"
      >
        <l-tile-layer
          :url="url"
          :attribution="attribution"
        />
        
        <l-marker v-if="preRegisteredValues!==null" :lat-lng="{lat:preRegisteredValues.y,lng:preRegisteredValues.x}">
          <!--<l-tooltip :content="tooltipContent" :options="{ permanent: true }" />-->
        </l-marker>
      </l-map>
    </div>
</template>
<script>
import { latLng,latLngBounds } from "leaflet";
import { LMap, LTileLayer, LMarker } from "vue2-leaflet";
import { OpenStreetMapProvider } from "leaflet-geosearch";
import { icon } from "leaflet";
import "leaflet-geosearch/dist/geosearch.css";

// eslint-disable-next-line  
delete L.Icon.Default.prototype._getIconUrl  
// eslint-disable-next-line  
L.Icon.Default.mergeOptions({  
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),  
  iconUrl: require('leaflet/dist/images/marker-icon.png'),  
  shadowUrl: require('leaflet/dist/images/marker-shadow.png')  
})


export default {
  components: {
    LMap,
    LTileLayer,
    LMarker
  },
  props:{
    id:{
      type: Number,
      default: 0
    },
    preRegisteredValues: {
      type:Object,
      default: ()=> {return {}}
    }
  },
  data(){
    return {
      mapOptions: {
        minZoom:13
      },
      
      zoom: 13,
      center: latLng(-34.92185683185205, -57.954678492025124),
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      attribution:
        '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors',
      
      geoSearchOptions: {
        provider: new OpenStreetMapProvider(),
        showMarker: false,
        autoClose: true
      },
      icon: icon({
        iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
        iconUrl: require("leaflet/dist/images/marker-icon.png"),
        shadowUrl: require("leaflet/dist/images/marker-shadow.png")
      }),
    }
  },
  computed:{
    maxBounds:{
      get(){
        return latLngBounds([
          [this.preRegisteredValues.y, this.preRegisteredValues.x]
        ])
      }
    }
  }
}
</script>
